import React from 'react';
import classnames from 'classnames';

interface IRadioBtnProps {
  name: string;
  value: any;
  checked?: boolean;
  className?: string;
  checkedClassName?: string;
  unCheckedClassName?: string;
  btnClassName?: string;
  id?: string;
  onChange?: (e: any, value?: any) => void;
}

const RadioBtn: React.FC<React.PropsWithChildren<IRadioBtnProps>> = ({
  name,
  value,
  checked,
  onChange,
  className,
  children,
  unCheckedClassName = 'text-primary-1 bg-gray-100',
  checkedClassName = 'bg-primary-1 text-white',
  btnClassName,
  id,
}) => {
  function handleChange(e) {
    onChange?.(e, value);
  }
  return (
    <label
      htmlFor={id}
      className={classnames('block cursor-pointer RadioBtn', className)}
    >
      <input
        type="radio"
        className="hidden w-0 h-0 opacity-0 appearance-none"
        onChange={handleChange}
        name={name}
        value={value}
        id={id}
      />
      <button
        className={classnames(
          'px-4 py-2 focus:outline-none pointer-events-none block w-full',
          btnClassName,
          {
            [unCheckedClassName]: !checked,
            [checkedClassName]: checked,
          }
        )}
      >
        {children}
      </button>
    </label>
  );
};
export default RadioBtn;
